// src/services/userService.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Assuming the same custom axiosBaseQuery is used
import {
  USER_DETAILS,
  USER_EDIT,
  USER_EXPORT,
  USER_LIST,
  STAFF_ADD,
  STAFF_DELETE,
  DASHBOARD,
  DASHBOARD_REVENUE,
} from "../../config/constants"; // Adjust endpoints as per your config

const userService = createApi({
  reducerPath: "userService",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  tagTypes: ["User"],
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: (bodyData) => ({
        url: USER_LIST, // Endpoint to fetch user list
        method: "POST",
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["User"],
    }),
    getUserDetails: builder.query({
      query: (id) => ({
        url: `${USER_DETAILS}/${id}`, // Endpoint to fetch user details
        method: "GET",
      }),
    }),
    // addUser: builder.mutation({
    //   query: (userData) => ({
    //     url: USER_ADD, // Endpoint to add a user
    //     method: "POST",
    //     data: userData, // User data for the request body
    //   }),
    //   invalidatesTags: ["User"],
    // }),
    addStaff: builder.mutation({
      query: (userData) => ({
        url: STAFF_ADD, // Endpoint to add a staff
        method: "POST",
        data: userData, // Meal data for the request body
      }),
      invalidatesTags: ["User"],
    }),
    updateUser: builder.mutation({
      query: ({ userId, updatedData }) => ({
        url: `${USER_EDIT}/${userId}`, // Endpoint to update a user
        method: "PUT",
        data: updatedData, // Updated user data
      }),
      invalidatesTags: ["User"],
    }),
    deleteUser: builder.mutation({
      query: (userId) => ({
        url: `${STAFF_DELETE}/${userId}`, // Endpoint to delete a user
        method: "DELETE",
      }),
      invalidatesTags: ["User"],
    }),

    getUsersExportFile: builder.mutation({
      query: (bodyData) => ({
        url: USER_EXPORT, // Endpoint to fetch ingredient list
        method: "GET",
      }),
    }),
    getDashBoardData: builder.query({
      query: () => ({
        url: DASHBOARD, // Endpoint to fetch dashboard data
        method: "GET",
      }),
    }),
    addRevenueDashboardData: builder.query({
      query: (userData) => ({
        url: DASHBOARD_REVENUE, // Endpoint to add a staff
        method: "POST",
        data: userData, // Meal data for the request body
      }),
      //invalidatesTags: ["User"],
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetUsersQuery,
  useGetUserDetailsQuery,
  // useAddUserMutation,
  useUpdateUserMutation,
  useAddStaffMutation,
  useDeleteUserMutation,
  useGetUsersExportFileMutation,
  useGetDashBoardDataQuery,
  useAddRevenueDashboardDataQuery,
} = userService;

// Export the reducer to be included in the store
export default userService;
